/**
 * Nature d'un défi (CIA / championnat / libre / …)
 * — miroir frontend de backend/src/lib/defi-kind.ts
 */

export const COMPETITION_ID_CHAMPIONNAT_EQUIPE = 1;
export const COMPETITION_ID_CIA = 2;

export type DefiKind =
  | 'cia'
  | 'championnat_equipe'
  | 'par_equipe'
  | 'libre'
  | 'ouvert'
  | 'quadrette'
  | 'entrainement'
  | 'unknown';

export interface DefiMetaInput {
  nomtable?: string | null;
  sqlIdMatch?: number | null;
  idCompetition?: number | null;
  cia?: boolean | null;
  championnatEquipe?: boolean | null;
  quadrette?: boolean | null;
  defiLibre?: boolean | null;
  defiOuvert?: boolean | null;
  entrainement?: boolean | null;
  urlResultats?: string | null;
  defiKind?: DefiKind | string | null;
}

function stripAccents(value: string): string {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function resolveDefiKind(input: DefiMetaInput = {}): DefiKind {
  if (input.defiKind && input.defiKind !== 'unknown') {
    return input.defiKind as DefiKind;
  }
  if (input.cia === true || input.idCompetition === COMPETITION_ID_CIA) {
    return 'cia';
  }
  if (
    input.championnatEquipe === true
    || input.idCompetition === COMPETITION_ID_CHAMPIONNAT_EQUIPE
  ) {
    return 'championnat_equipe';
  }
  if (input.entrainement === true) return 'entrainement';
  if (input.quadrette === true) return 'quadrette';
  if (input.defiOuvert === true) return 'ouvert';

  const url = (input.urlResultats || '').toLowerCase();
  if (url.includes('championnat_indiv')) return 'cia';
  if (url.includes('championnat_eq')) return 'championnat_equipe';

  const nom = stripAccents(String(input.nomtable || '')).toLowerCase();
  if (nom.includes('defi cia') || nom.startsWith('cia')) return 'cia';
  if (nom.includes('entrainement')) return 'entrainement';
  if (nom.includes('quadrette')) return 'quadrette';
  if (nom.includes('ouvert')) return 'ouvert';
  if (nom.includes('par equipe')) return 'par_equipe';
  if (nom.includes('defi libre')) return 'libre';
  if (input.defiLibre === true) return 'libre';
  if (nom.includes('defi')) return 'unknown';
  return 'unknown';
}

export function defiKindLabel(kind: DefiKind | string | null | undefined): string {
  switch (kind) {
    case 'cia': return 'CIA';
    case 'championnat_equipe': return 'Championnat par équipe';
    case 'par_equipe': return 'Défi par équipe';
    case 'libre': return 'Défi libre';
    case 'ouvert': return 'Défi ouvert';
    case 'quadrette': return 'Défi quadrette';
    case 'entrainement': return 'Entraînement';
    default: return 'Défi';
  }
}

export function enrichGameTableDefiMeta<T extends DefiMetaInput>(table: T): T & {
  defiKind: DefiKind;
  defiKindLabel: string;
  cia: boolean;
  championnatEquipe: boolean;
} {
  const defiKind = resolveDefiKind(table);
  return {
    ...table,
    defiKind,
    defiKindLabel: defiKindLabel(defiKind),
    cia: Boolean(table.cia) || defiKind === 'cia',
    championnatEquipe: Boolean(table.championnatEquipe) || defiKind === 'championnat_equipe',
  };
}
